import React, { useEffect, useState } from "react";
import ToggleButton from "../UI/ToggleButton";
import StatsCards from "../UI/StatsCards";
import BarGraph from "../UI/BarGraph";
import styles from "../../_css/CostSection.module.css";
import { DataLoader } from "../common/ResponseLoader";
import { fetchCostData } from "../../requests";
import { deleteAuthToken } from "../../utils/helper";

const costData = [180, 200, 400, 300, 120, 470, 130, 420, 110, 240, 410, 130];
const costLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const STATS_DATA = [
  {
    title: "Total OpenAI Cost",
    content: "$213,400",
    info: "+8% Compared to previous 12 month",
    icon: "6",
    color: "dark",
  },
  {
    title: "Average Cost per User",
    content: "$41.67",
    info: "Calculated using 360 users in selected period",
    icon: "5",
    color: "blue",
  },
  {
    title: "Average Cost per Session",
    content: "$31.12",
    info: "Includes all chats and voice sessions",
    icon: "4",
    color: "green",
  },
];

const STATS_DATA_ELEVENLABS = [
  {
    title: "Total ElevenLabs Cost",
    content: "$213,400",
    info: "+8% Compared to previous 12 month",
    icon: "6",
    color: "dark",
  },
  {
    title: "Average Cost per User",
    content: "$41.67",
    info: "Calculated using 360 users in selected period",
    icon: "5",
    color: "blue",
  },
  {
    title: "Average Cost per Session",
    content: "$31.12",
    info: "Includes all chats and voice sessions",
    icon: "4",
    color: "green",
  },
];

function CostSection() {
  const [selected, setSelected] = useState("OPENAI COST");
  const [isLoading, setIsLoading] = useState(false);
  const [graphData, setGraphData] = useState({});
  const [eachGraphData, setEachGraphData] = useState([]);
  const [statsData, setStatsData] = useState([]);
  const [selectedStatsData, setSelectedStatsData] = useState([]);

  useEffect(() => {
    getCostsGraphData();
  }, []);

  const getCostsGraphData = async () => {
    setIsLoading(true);
    try {
      const response = await fetchCostData();
      setStatsData(response.data.cost_data.stats_data);
      setSelectedStatsData(response.data.cost_data.stats_data.openai);
      setGraphData(response.data.monthly_data_all);
      setEachGraphData(response.data.monthly_data_all.openai);
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }
    setIsLoading(false);
  };

  const handleToggleChange = (value) => {
    console.log(graphData);
    
    setSelected(value);
    if (value === "OPENAI COST") {
      setSelectedStatsData(statsData?.openai);
      setEachGraphData(graphData?.openai);

    } else if (value === "ELEVENLAB COST") {
      setSelectedStatsData(statsData?.elevenlabs);
      setEachGraphData(graphData?.elevenlabs);
    } else {
      setSelectedStatsData(statsData?.aws_transcribe);
      setEachGraphData(graphData?.aws_transcribe);
    }
  };

  const formatText = (text) => {
    if(text === "OPENAI COST") {
      return "OpenAI cost"
    }
    else if(text === "ELEVENLAB COST") {
      return "Elevenlab cost"
    }
    else {
      return "AWS Transcribe cost"
    }
  }

  return (
    <div>
      <ToggleButton
        options={["OPENAI COST", "ELEVENLAB COST", "AWS TRANSCRIBE"]}
        value={selected}
        onChange={handleToggleChange}
      />
      {!isLoading ? (
        selectedStatsData.length > 0 && (
          <div key={selected} className={styles.costSectionRow}>
            <StatsCards data={selectedStatsData} variant="column" />
            <BarGraph
              title={`${formatText(selected)} per month`}
              data={eachGraphData}
              labels={costLabels}
            />
          </div>
        )
      ) : (
        <DataLoader />
      )}
    </div>
  );
}

export default CostSection;
